import React from 'react'
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
    mentorItemContainer: {
        position: 'relative',
    },
    mentorItem: {
        padding: '20px',
        textAlign: 'center',
        '@media only screen and (max-width: 768px)': {
            padding: '15px',
        },
        '@media only screen and (max-width: 380px)': {
            padding: '10px',
        },
        '& h2': {
            '@media only screen and (max-width: 480px)': {
                // fontSize: '20px',
            },
        },
        '& p': {
            '@media only screen and (max-width: 480px)': {
                fontSize: '13px',
            },
        },
        
    },
    mentorImage: {
        paddingBottom: '100%',
        position: 'relative',
        '& img': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '100%',
            width: '200px',
            height: '200px',
            maxHeight: '100%',
            objectFit: 'cover',
            zIndex: '-1',
            '@media only screen and (max-width: 768px)': {
                width: '150px',
                height: '150px',
            }
        },
    },
    mentorLock: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backdropFilter: 'blur(20px)',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        color: 'black',
        fontWeight: '600',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        zIndex: '10',
        '& img': {
            maxWidth: '50px',
            marginBottom: '10px',
        },
        '& p': {
            marginBottom: '0px',
            '@media only screen and (max-width: 380px)': {
                fontSize: '13px',
            },
        },
    },
    mentorLockBorder: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        border: '2px solid black',
        borderRadius: '10px',
        padding: '20px', 
        textAlign: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        transition: '0.2s background-color ease',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
        },
    },
})

function MentorItem(props) {

    var classes = useStyles()

    return (
        <div className={classes.mentorItemContainer}>
            {
                props.blur===1?
                <div className={classes.mentorLock}>
                    <div className={classes.mentorLockBorder + " cta-btn"}>
                        <img src="/pitchbattle/images/icons/padlock.png" alt="" />
                        <p>Register to Unlock</p>
                    </div>
                </div>: ""
            }
            <div className={classes.mentorItem}>
                
                <div className={classes.mentorImage}>
                    <img src={props.image} alt={props.name} />
                </div>
                <h2>{props.name}</h2>
                <p>{props.designation}</p>
            </div>
        </div>
    )
}

export default MentorItem
